"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const operators_1 = require("../operators");
const class_1 = require("../class");
const error_1 = require("../error");
exports.relationExpression = ({ ast, execObject, }) => {
    const [literals, operators] = Object.keys(ast.children).map((rule) => {
        // @ts-ignore
        if (!operators_1.RelationalOperatorTokens.includes(rule)) {
            return ast.children[rule].map((x) => {
                return execObject.interpreter({ ast: x, execObject });
            });
        }
        else {
            return ast.children[rule].map((x) => x.image);
        }
    });
    return literals.reduce((a, c, i) => {
        const name = c.name;
        return calc(name, operators, i - 1, a, c);
    });
};
const calc = (name, operators, i, a, b) => {
    let result = {};
    try {
        result = class_1.Classes[name][operators[i]](b, a);
    }
    catch (e) {
        throw new error_1.TypeError('演算子がありません。');
    }
    return result;
};
